export type BeneficiaryAccessPayload = {
	accountId: number;
	level: { readonly value: 'use' | 'supervise'; readonly label: string } | null;
};

export type BeneficiaryAccessFetchedAction = {
	type: 'BENEFICIARY_ACCESS_FETCHED';
	payload: BeneficiaryAccessPayload;
};

export default (
	accountId: number,
	level: BeneficiaryAccessPayload['level'],
): BeneficiaryAccessFetchedAction => ({
	type: 'BENEFICIARY_ACCESS_FETCHED',
	payload: { accountId, level },
});
